import {BaseBlock, theme} from "../../../framework/js/core";

export class Header extends BaseBlock {
  constructor(root) {
    super(root);
    this._sticky = false;
    this._minified = false;
    
    setInterval(() => root.find("#header-menu").removeClass("display-none"), 200);
    
    this.stickyThreshold = 200;
    this.fullHeight = this.root.outerHeight();
    this.heightKeeper = this.root.siblings(".site-header__height-keeper");
    this.menuButton = this.root.find(".site-header__menu-button");
    this.menu = this.root.find("#menu-main-menu");
    
    
    this.menuButton.on("click", event => {
      event.preventDefault();
      this.toggleMenu();
    });
  
    this.resizeReaction();
    $(window).on("resize", () => this.resizeReaction());
    
    this.scrollReaction();
    $(window).on("scroll", () => this.scrollReaction());
  }
  
  openMenu() {
    theme.body.addClass("mobile-menu-open");
    this.menu.slideDown();
    return this;
  }
  
  closeMenu() {
    theme.body.removeClass("mobile-menu-open");
    this.menu.slideUp();
    return this;
  }
  
  toggleMenu() {
    return theme.body.hasClass("mobile-menu-open") ? this.closeMenu() : this.openMenu();
  }
  
  resizeReaction() {
    if (theme.breakpoint("large").lesserW()) {
      if (this._minified) return;
      theme.body.addClass("header-minified");
      theme.emit("Header::minified");
      this.closeMenu();
      this._minified = true;
    } else {
      if (!this._minified) return;
      theme.body.removeClass("header-minified");
      theme.emit("Header::unminified");
      this.openMenu();
      this._minified = false;
    }
  }
  
  scrollReaction() {
    if (theme.breakpoint("large").greaterW() && window.pageYOffset > this.stickyThreshold) {
      if (this._sticky) return;
      this.fullHeight = this.root.outerHeight();
      this.heightKeeper.css({
        display: "block",
        height: this.fullHeight
      });
      theme.body.addClass("header-sticky");
      theme.emit("Header::stick");
      this._sticky = true;
    } else {
      if (!this._sticky) return;
      this.heightKeeper.css({
        display: "none"
      });
      theme.body.removeClass("header-sticky");
      theme.emit("Header::unstick");
      this._sticky = false;
    }
  }
}